export default {
  computed: {
    orgnInheritSign() {
      const sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
      return sessionData.orgnInheritSign;
    },
  },

  mounted() {
    this.listRole();
  },
  methods: {
    // 角色下拉选项数据
    listRole() {
      const sessData = JSON.parse(sessionStorage.getItem('sessionData'));
      const { roleId } = sessData;
      const params = {
        data: {
          id: roleId,
        },
      };
      return this.$_post(this.$API.roleListByLevel, params).then((res) => {
        this.roleDropList = res.data.list;
      });
    },
    // 加载机构树子节点
    listChildOrg(node, resolve) {
      const sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
      if (node.level === 0) {
        return resolve([
          {
            name: sessionData.orgnName,
            orgnCode: sessionData.orgnCode,
          },
        ]);
      }
      const params = {
        data: {
          orgnCode: node.data.orgnCode,
          orgnInheritSign: this.orgnInheritSign,
        },
      };
      return this.$_post(this.$API.subOrganizationList, params).then((res) => {
        function transformList(list) {
          if (!list || list.length === 0) {
            return [];
          }
          return list.map(item => ({
            name: item.title,
            orgnCode: item.id,
          }));
        }
        resolve(transformList(res.data.info.children));
      });
    },
    // 渲染树节点
    renderOrgTreeItem(h, { data }) {
      const { name } = data;
      if (name.length > 15) {
        return (
          <el-tooltip placement="right" content={name}>
            <span class="ellipsis">{name}</span>
          </el-tooltip>
        );
      }
      return <span>{name}</span>;
    },
  },
};
